export const SET_ORDER = 'SET_ORDER';
export const SET_ASSET = 'SET_ASSET';
export const SET_CLIENT = 'SET_CLIENT';
export const SET_CONTRACT = 'SET_CONTRACT';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PROMOTION = 'SET_PROMOTION';
export const RESET = 'RESET';
